import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@mui/material";
import { red } from "@mui/material/colors";
import { darken } from "@mui/material/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#A6192E",
      hover: darken("#A6192E", 0.1),
    },
    secondary: {
      main: "#A6192E",
      hover: darken("#A6192E", 0.1),
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#F9F9FB",
    },
    light: {
      default: "#FFFFFF",
    },
    selected: {
      default: "#ffffff",
    },
    success: {
      main: "#3EA619",
    },
    icon: {
      main: "#A6192E",
    },
  },
  typography: {
    fontFamily: [
      "Figtree",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // Name of the rule
          paddingLeft: "5px",

          "&.Mui-focused": {
            // increase the specificity for the pseudo class
            padding: "0 5px 0 5px",
            backgroundColor: "white",
          },
          "&.MuiFormLabel-filled": {
            padding: "0 5px 0 5px",
            backgroundColor: "white",
          },
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          "&:before": {
            borderBottom: "none !important", // Customize thickness and color here
          },
          "&:hover:before": {
            borderBottom: "none", // Ensure it doesn’t reappear on hover
          },
          margin:"10px"
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          // Your custom styles for the dialog paper
          width: "50%",
          padding: "10px",
          borderRadius: "10px",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          backgroundColor: "#E1E2E7",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          "&.Mui-selected": {
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
            },
            backgroundColor: theme.palette.primary.main,
          },
          borderRadius: "10px",
          marginLeft: "8px",
          marginRight: "8px",
        }),
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          minHeight: 0,
        }),
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          borderRadius: "10px",
          border: "1px solid #D2D1D3",
        }),
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          height: "40px",
          borderRadius: "10px",

          boxShadow: "none",
        }),
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          padding: "8px 20px",
          borderRadius: "10px",
          fontSize: "16px",
          color: "#fff",
          backgroundColor: theme.palette.primary.main
        }),
        contained: ({ theme }) => ({
          color: "#fff",
          backgroundColor: theme.palette.primary.main,
          "&:hover": {
            backgroundColor: darken(theme.palette.primary.main, 0.1),
          },
        }),
        outlined: ({ theme }) => ({
          color: theme.palette.primary.main,
          backgroundColor: "#ffffff",
          border: `1.5px solid ${theme.palette.primary.main}`,
          "&:hover": {
            backgroundColor: darken("#ffffff", 0.1),
          },
        }),
        startIcon: {
          '& .MuiSvgIcon-root': {
            fontSize: "30px",
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          "&. MuiTypography-root": {
            fontSize: "14px",
          },
          fontSize: "14px",
        }),
      },
    },
  },
});
